export default "__VITE_ASSET__D46wS1io__"